import { TInputAppEnvironmentVars } from '@monorepo/types';
import { NgxLoggerLevel } from 'ngx-logger';

export const environment: TInputAppEnvironmentVars = {
  production: false,
  mode: 'kalpha',
  channel: 'kalpha',
  environmentName: 'kalpha Environment',
  ionicEnvName: 'kalpha',
  protocol: 'https://',
  service_host: 'tracki8app.kalpha.strawmine.com',
  factory_admin_host: 'kalpha-n-factory-configuration-admin-external.strawmine.com/ext',
  log_hbase_host: 'kalpha-n-core-cate-data-mediator-external.strawmine.com/ext',
  ws_protocol: 'wss://',
  // [TODO](kuldeep/hitendra): confirm and remove this from devops
  ws_host: 'kalpha-service-external.strawmine.com',
  ws_api: '/wsapi/wsopen',

  auth_services: '/auth_services/ext',
  licence_services: '/licence_services/ext',
  image_service: '/image_service/ext',
  data_services: '/flow_services/ext',
  input_services: '/input_service_api/ext',
  app_img_service: '/image_service/ext',
  deploy_services: '/deploy_services/ext',
  event_services: '/event_services/ext',
  store_data_services: '/store_data_services/ext',
  tags_services: '/tags_services/ext',
  event_hub: '/event_hub/ext',
  order_data_services: '/app_order_data_services/ext',
  bctx_services: '/bctx_services/ext',
  data_gateway: '/data_gateway/ext',
  core_services: '/core_services/ext',
  shift_service: '/shift_services/ext',
  master_data_services: '/core_services/ext',
  upload_defect_images: '',
  fabric_service_host: '',
  packing_services: '/packing_tool/ext',
  bulk_count_app_services: '/generic_app/ext',
  logging: {
    level: NgxLoggerLevel.DEBUG,
    serverLogLevel: NgxLoggerLevel.ERROR,
    serverLoggingUrl: 'https://factoryadmin.kalpha.strawmine.com/deploy_services/ext/devicestatus/v1/errors',
  },
};
